// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalNavbar-cls1_AEL","cls2":"JournalNavbar-cls2_6Rp JournalNavbar-cls1_AEL"};